import { useState } from 'react';
import { storageUrlFromPath } from '../lib/upload';

type Props = {
  label: string;
  currentPath: string | null;
  maxKb?: number;
  accept?: string;
  onPick: (file: File) => void;
};

export function ImageUploadField({
  label,
  currentPath,
  maxKb = 8096,
  accept = 'image/png,image/jpeg,image/jpg,image/gif',
  onPick,
}: Props) {
  const [error, setError] = useState('');
  const [preview, setPreview] = useState<string | null>(null);
  const shown = preview ?? storageUrlFromPath(currentPath);

  return (
    <div className="mb-3">
      <label className="form-label fw-semibold">{label}</label>
      {shown && (
        <img
          src={shown}
          alt="preview"
          style={{ display: 'block', maxHeight: 120, marginBottom: 8, objectFit: 'contain' }}
        />
      )}
      <input
        type="file"
        className="form-control"
        accept={accept}
        onChange={(e) => {
          const f = e.target.files?.[0];
          if (!f) return;
          if (f.size / 1024 > maxKb) {
            setError(`File must be <= ${maxKb} KB`);
            return;
          }
          setError('');
          setPreview(URL.createObjectURL(f));
          onPick(f);
        }}
      />
      {error && <div className="text-danger small mt-1">{error}</div>}
    </div>
  );
}
